import axios from '@/services/api'

/**
 * @returns {Promise<Object>}
 */
export const getProfile = () => {
	return axios.get('/api/users/me?expand=public,private')
}

/**
 * @returns {Promise<Object>}
 */
export const fetchNotes = (queryParams = '') => {
	return axios.get(`/api/notes?${queryParams}`)
}

/**
 * @param {Number} noteId
 * @returns {Promise<Object>}
 */
export const fetchNoteById = (noteId) => {
	return axios.get(`/api/notes/${noteId}`)
}

/**
 * @returns {Promise<Object>}
 */
export const fetchBookmarks = (queryParams = '') => {
	return axios.get(`/api/threads?filter=follow&${queryParams}`)
}

/**
 * @param {Number} userId
 * @param {Object} userData
 *
 * @returns {Promise<Object>}
 */
export const updateProfile = ({ userId, userData }) => {
	return axios.post(`/api/users/${userId}`, userData)
}

/**
 * @param {Object} noteData
 *
 * @returns {Promise<Object>}
 */
export const addNote = (noteData) => {
	return axios.post('/api/notes', noteData)
}

/**
 * @param {Number} noteId
 * @param {String} text
 *
 * @returns {Promise<Object>}
 */
export const updateNote = ({ id: noteId, text }) => {
	return axios.put(`/api/notes/${noteId}`, {follow_note: text})
}

/**
 * @param {Number} userId
 *
 * @returns {Promise<Object>}
 */
export const deleteNote = (userId) => {
	return axios.delete(`/api/notes/${userId}`)
}

/**
 * @returns {Promise<Object>}
 */
export const fetchMyPosts = () => {
	return axios.get('/api/profile/posts')
}

/**
 * @returns {Promise<Object>}
 */
export const fetchPostByUser = (userId) => {
	return axios.get(`/api/profile/${userId}/posts`)
}
